// tslint:disable-next-line: no-submodule-imports
import useStyles from 'isomorphic-style-loader/useStyles';
import React from 'react';
import { useSelector } from 'react-redux';
import { Grid, InfiniteLoader, WindowScroller } from 'react-virtualized';
import { computeContainerWidth } from '../../../utils/gridHelpers';
import * as Styles from './InfiniteGrid.scss';
import LoadingWidget from '../../LoadingWidget';
export default function InfiniteGrid(props) {
    var _a;
    useStyles(Styles);
    // Grab data from props and Redux store.
    const { data, handleSelected, gridSizes, isEnumerated } = props;
    const { onEndOfWidget, items } = data;
    const { colCount, colWidth, rowHeight } = gridSizes;
    // Calculate grid sizing. 
    const { windowWidth } = useSelector((state) => state.BrowserState);
    const width = computeContainerWidth(windowWidth);
    // Functions to check when to load more items.
    const loadMoreItems = () => handleSelected(onEndOfWidget);
    const isRowLoaded = ({ index }) => {
        var _a;
        return index < (((_a = onEndOfWidget) === null || _a === void 0 ? void 0 : _a.length) ? items.length - 1 : items.length);
    };
    let renderRows;
    const onSectionRendered = ({ columnStartIndex, columnStopIndex, rowStartIndex, rowStopIndex }) => {
        const startIndex = rowStartIndex * colCount + columnStartIndex;
        const stopIndex = rowStopIndex * colCount + columnStopIndex;
        renderRows({ startIndex, stopIndex });
    };
    const showLoader = ((_a = onEndOfWidget) === null || _a === void 0 ? void 0 : _a.length) > 0;
    const Item = ({ columnIndex, key, rowIndex, parent, style }) => {
        const { columnCount, data: itemData } = parent.props;
        const TagType = parent.props.componentType;
        const index = rowIndex * columnCount + columnIndex;
        return itemData.items.length > index ? (React.createElement(TagType, { data: itemData.items[index], handleSelected: itemData.handleSelected, key: key, style: style, position: isEnumerated ? index + 1 : undefined })) : null;
    };
    return (React.createElement("div", null,
        React.createElement(InfiniteLoader, { isRowLoaded: isRowLoaded, loadMoreRows: loadMoreItems, rowCount: items.length, threshold: 1 }, ({ onRowsRendered, registerChild }) => {
            renderRows = onRowsRendered;
            return (React.createElement(WindowScroller, null, ({ height, scrollTop }) => (React.createElement(Grid, { className: Styles.grid, autoHeight: true, componentType: props.componentType, data: { items, handleSelected }, width: width, height: height, scrollTop: scrollTop, ref: registerChild, columnCount: colCount, columnWidth: colWidth, rowCount: Math.ceil(items.length / colCount), rowHeight: rowHeight, cellRenderer: Item, onSectionRendered: onSectionRendered }))));
        }),
        showLoader && React.createElement(LoadingWidget, null)));
}
